// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_27m0aapiYgbHq3SZo2hXYq","large":"_3gN8UNI9Vzlsbpl3c9L4rx"};